
const HelpData = [
    {
        category: "Getting Started",
        tabs: [
            { title: "Introduction", link: "/docs/introduction" },
            {
                title: "Admin",
                link: "/docs/church",
                children: [
                    { title: "Church", link: "/docs/church" },
                     { title: "Ministries", link: "/docs/ministries" },
                    { title: "Leadership Team", link: "/docs/leadership-team" },
                    { title: "Leadership", link: "/docs/leadership" },
                    { title: "Family", link: "/docs/family" },
                    { title: "Members", link: "/docs/members" },
                    { title: "Schedule", link: "/docs/schedule" },
                    { title: "Events", link: "/docs/events" },
                    { title: "Notifications", link: "/docs/notifications" },
                    { title: "Logs", link: "/docs/logs" },
                    { title: "Login Devices", link: "/docs/login-devices" },
                    { title: "Tickets", link: "/docs/tickets" },
                ]
            },
            {
                title: "Member",
                link: "/docs/home",
                children: [
                    { title: "Home", link: "/docs/home" },
                    { title: "Directory", link: "/docs/directory" },
                    { title: "Schedules", link: "/docs/member-schedules" },
                    { title: "Event", link: "/docs/member-events" },
                    { title: "Faq", link: "/docs/members-faq" },
                    { title: "Notifications", link: "/docs/member-notifications" },
                    { title: "Leadership", link: "/docs/member-leadership" },
                    { title: "My Account", link: "/docs/member-my-account" },
                ]
            },
            { title: "Mobile App", link: "/docs/mobile-app" },
        ],
    },
];

export default HelpData;